import { Product } from '../../types/Product';

export const generateMenuPrompt = (
  products: Product[],
  budget: number,
  dishCount: number
): string => {
  const productContext = products.map(product => {
    return `- ${product.display_name}:
  * Precio: ${product.current_price}€
  * Categoría: ${product.category_name}
  * Marca: ${product.brand}`;
  }).join('\n');

  return `Como chef experto, genera un menú completo y detallado utilizando los siguientes productos disponibles:

${productContext}

Requisitos del menú:
- Presupuesto máximo: ${budget}€
- Número de platos: ${dishCount}
- Debe ser equilibrado nutricionalmente
- Incluir variedad de ingredientes y técnicas
- Respetar el presupuesto total
- Optimizar el uso de los ingredientes

El menú debe incluir:

1. Nombre creativo del menú
2. Descripción general y beneficios nutricionales
3. Para cada plato:
   - Nombre del plato
   - Ingredientes necesarios con cantidades exactas
   - Coste detallado de los ingredientes
   - Tiempo de preparación
   - Instrucciones paso a paso
   - Consejos de emplatado
4. Sugerencias de combinación
5. Coste total del menú
6. Consejos de preparación y organización

Formatea la respuesta en HTML usando estas etiquetas para mejor legibilidad:
- <h3> para títulos de secciones
- <h4> para nombres de platos
- <p> para descripciones
- <ul> y <li> para listas
- <strong> para destacar información importante
- <em> para consejos y notas

Asegúrate de que el menú sea práctico, realista y fácil de seguir.`;
};